import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

import en_lang from './cookieconsent-en.json' with {type: "json"};
import de_lang from './cookieconsent-de.json' with {type: "json"};


// Enable dark mode for cookie consent.
document.documentElement.classList.add('cc--darkmode');

const ccEnableGoogleReviews = function() {
   // console.log("ccEnableGoogle");
   const el = document.querySelector("#testimonials");
   el.classList.remove('hidden');

   // Show testimonials nav menu item
   const el_menus = document.querySelectorAll(".testimonials-navitem");
   for (let i = 0; i < el_menus.length; i++) {
     const el_m = el_menus.item(i);
     el_m.classList.remove('hidden');
   }
}

const ccDisableGoogleReviews = function() {
   // console.log("ccDisableGoogle");
   const el = document.querySelector("#testimonials");
   el.classList.add('hidden');

   // Hide testimonials nav menu item
   const el_menus = document.querySelectorAll(".testimonials-navitem");
   for (let i = 0; i < el_menus.length; i++) {
     const el_m = el_menus.item(i);
     el_m.classList.add('hidden');
   }
}

const ccEnableContact = function() {
  // console.log("ccEnableContact");
  const el = document.querySelector("#contact");
  el.classList.remove('hidden');

  const el_fallback = document.querySelector("#contact-fallback");
  el_fallback.classList.add('hidden');

  // Rewrite anchor targets for contact links to elfsight section
  const contact_links = document.getElementsByClassName("cc-contact-link");
  for (let i = 0; i < contact_links.length; i++) {
    const el = contact_links.item(i);
    el.href = "#contact";
  }
};

const ccDisableContact = function() {
  // console.log("ccDisableContact");
  const el = document.querySelector("#contact");
  el.classList.add('hidden');

  const el_fallback = document.querySelector("#contact-fallback");
  el_fallback.classList.remove('hidden');

  // Rewrite anchor targets for contact links to fallback
  const contact_links = document.getElementsByClassName("cc-contact-link");
  for (let i = 0; i < contact_links.length; i++) {
    const el = contact_links.item(i);
    el.href = "#contact-fallback";
  }
};

const ccEnableInsta = function() {
   // console.log("ccEnableInsta");
   // const el = document.querySelector(".lightwidget-widget");
   // el.src = 'https://cdn.lightwidget.com/widgets/c5bd652b55cc58f699b182d4c6d774c5.html'

   const el_section = document.querySelector("#insta");
   el_section.classList.remove('hidden');
};

const ccDisableInsta = function() {
   // console.log("ccDisableInsta");
   // const el = document.querySelector(".lightwidget-widget");
   // el.src = ''

   const el_section = document.querySelector("#insta");
   el_section.classList.add('hidden');
};

CookieConsent.run({
    guiOptions: {
        consentModal: {
            // layout: "box wide",
            // position: "middle center",
            layout: "bar",
            position: "bottom",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            // position: "bottom",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        functionality: {}
    },
    language: {
        default: "de",
        translations: {
          'en': en_lang,
          'de': de_lang
        },
        autoDetect: "browser"
    },
    disablePageInteraction: true,
    onConsent: function(){
       if(CookieConsent.acceptedService('elfsight.com', 'functionality')){
         // console.log("Consented Elfsight, cc manager enables script");
         ccEnableContact();
         ccEnableInsta();
         ccEnableGoogleReviews();
       } else {
         ccDisableContact();
         ccDisableInsta();
         ccDisableGoogleReviews();
         // // console.log("Rejected Elfsight, hiding. cc manager disables script.");
         // const el = document.querySelector("#contact");
         // el.classList.add('hidden');

         // // console.log("Showing fallback contact section.")
         // const el_fb = document.querySelector("#contact-fallback");
         // el_fb.classList.remove('hidden');
       }

       // if(CookieConsent.acceptedService('lightwidget.com', 'functionality')){
       //   ccEnableInsta();
         // // console.log("Consented Lightwidget, showing.");
         // const el = document.querySelector(".lightwidget-widget");
         // el.classList.remove('hidden');
         // el.src = 'https://cdn.lightwidget.com/widgets/c5bd652b55cc58f699b182d4c6d774c5.html'
       // } else {
       //   ccDisableInsta();
         // // console.log("Rejected Lightwidget, hiding.");
         // const el = document.querySelector("#insta");
         // el.classList.add('hidden');
       // }
    },
    onChange: function({changedCategories, changedServices}) {
      // console.log("cc changed");

      //if(changedCategories.includes('functionality')){

        if(CookieConsent.acceptedCategory('functionality')){
          // Just enabled all functionality cookies
          // console.log("Functionality cookies enabled, doing nothing globally..");
          // ccEnableContact();
          // ccEnableGoogle();
          // ccEnableInsta();

//            const el = document.querySelector(".lightwidget-widget");
//            el.src = 'https://cdn.lightwidget.com/widgets/c5bd652b55cc58f699b182d4c6d774c5.html'

//            const el_contact = document.querySelector("#contact");
//            el_contact.classList.remove('hidden');

//            const el_fb = document.querySelector("#contact-fallback");
//            el_fb.classList.add('hidden');

//            const el_testimonials = document.querySelector("#testimonials");
//            el_testimonials.classList.remove('hidden');
//            const el_insta = document.querySelector("#insta");
//            el_insta.classList.remove('hidden');

        } else {
          // console.log("Functionality cookies disabled, doing nothing globally");
          // ccDisableContact();
          // ccDisableGoogle();
          // ccDisableInsta();
          // // Just disabled all functionality cookies
          // // console.log("Functionality cookies disabled, removing lightwidget src and hiding sections");
          // const el = document.querySelector(".lightwidget-widget");
          // el.src = ''

          //  const el_contact = document.querySelector("#contact");
          //  el_contact.classList.add('hidden');
          //  const el_testimonials = document.querySelector("#testimonials");
          //  el_testimonials.classList.add('hidden');
          //  const el_insta = document.querySelector("#insta");
          //  el_insta.classList.add('hidden');

         // const el_fb = document.querySelector("#contact-fallback");
         // el_fb.classList.remove('hidden');
        }

        if(changedServices['functionality'].includes('elfsight.com')){
          if(CookieConsent.acceptedService('elfsight.com', 'functionality')){
            ccEnableContact();
            ccEnableInsta();
            ccEnableGoogleReviews();
           // // console.log("Changed Elfsight to accepted, showing.");
           // const el = document.querySelector("#contact");
           // el.classList.remove('hidden');
          } else {
           ccDisableContact();
           ccDisableInsta()
           ccDisableGoogleReviews();
           // // console.log("Changed Elfsight to rejected, hiding form and showing fallback.");
           // const el = document.querySelector("#contact");
           // el.classList.add('hidden');

           // const el_fb = document.querySelector("#contact-fallback");
           // el_fb.classList.remove('hidden');
          }
        }

        // if(changedServices['functionality'].includes('lightwidget.com')){

        //   if(CookieConsent.acceptedService('lightwidget.com', 'functionality')){
        //     ccEnableInsta();
            // // Just enabled
            // // console.log("Changed Lightwidget to enabled, set src and show");
            // const el = document.querySelector(".lightwidget-widget");
            // el.src = 'https://cdn.lightwidget.com/widgets/c5bd652b55cc58f699b182d4c6d774c5.html'
            // const el_section = document.querySelector("#insta");
            // el_section.classList.remove('hidden');
          // }else{
          //   ccDisableInsta();
            // // Just disabled
            // // console.log("Changed Lightwidget to disabled, unset src and hide");
            // const el = document.querySelector(".lightwidget-widget");
            // el.src = ''
            // const el_section = document.querySelector("#insta");
            // el_section.classList.add('hidden');
          // }
        // }
      //}
    }
});
